import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header/Header";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsappButton";
import { AppConfigFields, ContactInfoFields } from "../types/appConfigEntities";

const DefaultLayout: React.FC = () => {
  return (
    <div className="page-surface">
      <Header />

      <main style={{ position: "relative", zIndex: 2 }}>
        <Outlet />
      </main>

      <Footer companyName="Voda Argentina" year={new Date().getFullYear()} />

      <WhatsAppButton
        phoneNumber={
          window.APP_CONFIG[AppConfigFields.ContactData]?.[ContactInfoFields.Whatsapp]?.replace(/\D/g, "") || ""
        }
      />
    </div>
  );
};

export default DefaultLayout;
